import { PageHead } from "@nabble/ui";
import { Navigate, useParams } from "react-router-dom";
import { AccountSectionBody } from "./AccountSectionBody";
import { ACCOUNT_SECTIONS, accountPath } from "./accountSections";
import { AccountSectionsNav } from "./AccountSectionsNav";

/** My account: one view per item of the left list (`/account/<section>`). */
export default function AccountPage(): React.JSX.Element {
  const { section } = useParams<{ section: string }>();
  const current = ACCOUNT_SECTIONS.find((s) => s.id === section);

  if (!current) return <Navigate to={accountPath("profile")} replace />;

  return (
    <div>
      <PageHead title="My account" subtitle={current.subtitle} />
      <div className="nb-settings">
        <AccountSectionsNav current={current.id} />
        <div className="nb-settings-body">
          <AccountSectionBody section={current.id} />
        </div>
      </div>
    </div>
  );
}
